import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from './../../common/dialog';

class SpeedTable extends Component {
    static propTypes = {
        speedTable: PropTypes.array,
        hideSpeedTable: PropTypes.func,
        handleUpdateSpeedTable: PropTypes.func,
        isSavingSpeedTable: PropTypes.bool,
        handleSaveSpeedTable: PropTypes.func,
        handleAddSpeedTable: PropTypes.func,
        handleDeleteSpeedTable: PropTypes.func
    };

    renderData() {
        const { speedTable, handleUpdateSpeedTable, handleDeleteSpeedTable } = this.props;
        return speedTable.map((speed, index) => {
            return (
                <tr key={index}>
                    <td>
                        <select name="" value={speed.is_over_size} onChange={handleUpdateSpeedTable.bind(this, index, 'is_over_size')}>
                            <option value="">Select option</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </td>
                    <td>
                        <input type="text" value={speed.width}
                            onChange={handleUpdateSpeedTable.bind(this, index, 'width')} />
                    </td>
                    <td>
                        <input type="text" value={speed.length}
                            onChange={handleUpdateSpeedTable.bind(this, index, 'length')} />
                    </td>
                    <td>
                        <input type="text" value={speed.thickness_limit}
                            onChange={handleUpdateSpeedTable.bind(this, index, 'thickness_limit')} />
                    </td>
                    <td>
                        <input type="text" value={speed.time_per_m_pieces_under_limit}
                            onChange={handleUpdateSpeedTable.bind(this, index, 'time_per_m_pieces_under_limit')} />
                    </td>
                    <td>
                        <input type="text" value={speed.time_per_m_pieces_over_limit}
                            onChange={handleUpdateSpeedTable.bind(this, index, 'time_per_m_pieces_over_limit')} />
                    </td>
                    <td>
                        <div className="action-icon">
                            <i className="fas fa-trash" onClick={handleDeleteSpeedTable.bind(this, index)} />
                        </div>
                    </td>
                </tr>
            );
        });
    }

    render() {
        const { hideSpeedTable, handleSaveSpeedTable, isSavingSpeedTable, handleAddSpeedTable } = this.props;

        let data = (
            <div>
                <table className="table table-sm table-striped data-table">
                    <thead>
                        <tr>
                            <th>Is Over Size?</th>
                            <th>Width</th>
                            <th>Length</th>
                            <th>Thickness Limit</th>
                            <th>Time Less/Equal than Thickness Limit</th>
                            <th>Time Greater Than Thickness Limit</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>{this.renderData()}</tbody>
                </table>
                <div className="add-button" onClick={handleAddSpeedTable} style={{ width: 120, fontSize: 13 }}><i className="fas fa-plus" /> Add Row</div>
            </div>
        );

        let saveButtonLabel = 'Save';
        if (isSavingSpeedTable) {
            saveButtonLabel = <i className="fas fa-circle-notch fa-spin" />;
        }

        let actions = [
            <button key="save-button" className="btn btn-light btn-sm action-button"
                onClick={handleSaveSpeedTable} disabled={isSavingSpeedTable}>{saveButtonLabel}</button>,
            <button key="close-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideSpeedTable}>Close</button>
        ];
        return (
            <Dialog
                name="speed-table"
                modal={false}
                actions={actions}
                contentStyle={{ width: 800 }}
                bodyStyle={{ overflow: 'initial' }}
            >
                <div className="form-container">{data}</div>
            </Dialog>
        );
    }
}

export default SpeedTable;
